import { environment } from '@env/environment';

export const STORAGE_SSO = environment.localStorageName + '_from_sso';
